module.exports = __webpack_public_path__ + "img/hc_pro_three_2.19d01b8c.jpg";